import { createSlice } from "@reduxjs/toolkit";
import { sagaActions } from "../sagas/sagaActions";
import { removeSessionStorage, setSessionStorage } from "../../helper/Storage";

const initialState = {
  user: {},
  error: "",
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(sagaActions.USER_LOGIN, (state, action) => {
        state.user = action.data.data;
        state.error = action.data.error;
        setSessionStorage("token", action?.data?.data?.token);
      })
      .addCase(sagaActions.USER_LOGIN_FAILED, (state, action) => {
        state.user = {};
        state.error = action.data.error;
        removeSessionStorage("token");
      })
      .addCase(sagaActions.USER_LOGOUT_FAILED, (state, action) => {
        state.user = {};
        state.error = action.data.error;
        removeSessionStorage("token");
      })
      .addCase(sagaActions.USER_LOGOUT, (state, action) => {
        state.user = {};
        state.error = "";
        removeSessionStorage("token");
      });
  },
});

export default userSlice.reducer;
